import { IconX } from '@tabler/icons-react'
import noop from 'lodash/noop'
import { createRef, MouseEvent } from 'react'

import { SizeOptions } from '../../../../types/types'
import { AstraChip } from '../../../AstraChip/AstraChip'
import { AstraIcon } from '../../../AstraIcon/AstraIcon'
import { MultiValueProps } from '../types/types'

export type AstraMultiSelectMultiValueProps<T> = {
    label: MultiValueProps<T>['data']['label']
    removeProps: MultiValueProps<T>['removeProps']
    size: SizeOptions
    isDisabled?: MultiValueProps<T>['isDisabled']
    readOnly?: boolean
}

export const AstraMultiSelectMultiValue = <T,>({ label, removeProps, size, isDisabled, readOnly }: AstraMultiSelectMultiValueProps<T>) => {
    const chipRef = createRef<HTMLDivElement>()

    const onClick = (event: MouseEvent<HTMLDivElement>) => {
        event.preventDefault()
        event.stopPropagation()
        removeProps.onClick?.(event)
    }

    return (
        <div data-multivalue-chip ref={chipRef} {...removeProps} onClick={onClick} className="flex min-w-fit max-w-full shrink-0 basis-auto">
            <AstraChip
                variant="filled"
                label={label}
                size={size}
                color={readOnly ? 'default' : 'default-interactive'}
                onClick={noop}
                endIcon={<AstraIcon icon={IconX} size="small" />}
                truncated
                disabled={isDisabled}
            />
        </div>
    )
}
